<script setup></script>

<template>askbot</template>
